import React from 'react'
import { isNullOrWhiteSpace } from '../utilities/string'
import { Box } from './Box'
import { Attachment, ReportAttachmentsList } from './ReportAttachmentsList'

export interface Review {
  attachments?: Attachment[]
  title?: string
}

export interface AnnualReviewsBoxProps {
  review: Review
}

export const AnnualReviewsBox = ({ review }: AnnualReviewsBoxProps) => {
  const { attachments, title } = review

  return (
    <Box
      additionalClassName="w-full"
      disableGroupHover
      padding="px-30 pt-30 pb-45 md:pt-45 md:px-45 lg:pb-60 xl:px-60"
      paddingStyle="custom"
      variant="border"
    >
      {!isNullOrWhiteSpace(title) && (
        <h3 className="mb-20 text-secondary-dark font-h3 text-h3">{title}</h3>
      )}

      {!!attachments?.length && <ReportAttachmentsList attachments={attachments} />}
    </Box>
  )
}
